import React, { FC } from 'react';
import { PlatformType } from '@okletsplay/core';
import { TournamentEntity } from 'app/interfaces/entity';
import { OkLetsPlayTournamentStatus } from 'modules/tournaments/components/TournamentStatus/OkLetsPlayTournamentStatus';
import { KnockoutTournamentStatus } from 'modules/tournaments/components/TournamentStatus/KnockoutTournamentStatus';
import { TournamentStatusViewType } from 'modules/tournaments/enums';
import { useTournamentPlatformType } from 'modules/tournaments/hooks';

interface TournamentStatusProps {
  tournament: TournamentEntity;
  viewType?: TournamentStatusViewType;
  showStatus?: boolean;
}

export const TournamentStatus: FC<TournamentStatusProps> = ({
  tournament,
  viewType,
  showStatus = true,
}) => {
  const platformType = tournament?.game?.platformType;

  const { checkIsKnockoutEnabled } = useTournamentPlatformType();
  const isKnockoutTournament = checkIsKnockoutEnabled(platformType);

  switch (true) {
    case platformType === PlatformType.Steam:
      return <></>;
    case isKnockoutTournament:
      return (
        <KnockoutTournamentStatus
          tournament={tournament}
          viewType={viewType}
          showStatus={showStatus}
        />
      );
    default:
      return <OkLetsPlayTournamentStatus tournament={tournament} viewType={viewType} />;
  }
};
